import React, { useEffect, useState } from 'react';
import { POPUP_KEY_ASSIGN_GROUP } from '../../constant';
import { popupOpenService } from '../../shared/popupOpenService';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import { PREFERENCE_URL, deleteFetchRequest, postFetchRequest } from '../../store/requests';
import Modal from '../Modal';
import { MODAL_SMALL_SIZE } from '../helper';
import { useTranslation } from 'react-i18next';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import AssignPreferenceGroupsList from './AssignPreferenceGroupsList';
import {errorCallback, makeUrl} from "../../util";
import { Button } from '@chapche/ui';

const AssignGroupModalContent = ({ handleClose, assignPreferences }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="block__title-h3 preference__group-subtitle">
                {i18n.t('app.page.preference.preferenceAssignGroup')}
            </h2>
            <AssignPreferenceGroupsList />
            <div className="modal__button-group">
                <Button className="preference__users-button" onClick={handleClose}>
                    {i18n.t('app.page.preference.modal.cancel')}
                </Button>
                <Button variant="outline" className="preference__users-button" onClick={assignPreferences}>
                    {i18n.t('app.page.preference.modal.assign')}
                </Button>
            </div>
        </>
    );
};

const prepareGroupsBody = () => {
    const preparedList = [];
    preferencesGroupsStorage.getSelectedList().forEach(it => preparedList.push({groupId: it.id}));
    return preparedList;
};

const AssignGroupToPreferencePopup = ({ notifyPreferencesList }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenModal = () => {
        setIsOpen(true);
        if(preferencesStorage.getSelectedPreferencesList().length === 1) {
            preferencesStorage.getSelectedPreferencesList()[0].groups.forEach(it => preferencesGroupsStorage.changeSelectedPreferenceGroups(it.id));
        }
    };    
    
    useEffect(() => {
        popupOpenService.registerPopup(POPUP_KEY_ASSIGN_GROUP, handleOpenModal);
        return () =>{
            popupOpenService.unRegisterPopup(POPUP_KEY_ASSIGN_GROUP, handleOpenModal);
            preferencesGroupsStorage.changeSelectedPreferenceGroups('', true);
        };
    },[]);

    const closePopup = () => {
        setIsOpen(false);
        preferencesGroupsStorage.changeSelectedPreferenceGroups('', true);
    };

    const assignPreferences = () => {        
        if(preferencesStorage.getSelectedPreferencesList().length) {
            for(let preference of preferencesStorage.getSelectedPreferencesList()) {
                if(preferencesStorage.getSelectedPreferencesList().length === 1) {
                    for(let group of preference.groups) {
                        if(!preferencesGroupsStorage.getSelectedList().find(it => it.id === group.id)) {
                            deleteFetchRequest(makeUrl([PREFERENCE_URL, preference.id, '/group/']), () => {}, errorCallback, [{groupId: group.id}]);
                        }
                    }
                }
                postFetchRequest(makeUrl([PREFERENCE_URL, preference.id, '/group/']), prepareGroupsBody(), () => {
                    notifyPreferencesList();
                    closePopup();
                    preferencesGroupsStorage.changeSelectedPreferenceGroups(null, true);
                    preferencesStorage.cleanSelectedPreferences();
                }, errorCallback, true);
            }
        }
    };

    return (
        isOpen ?
            <Modal content={<AssignGroupModalContent handleClose={closePopup} assignPreferences={assignPreferences} />}  
                handleCloseModal={closePopup} size={MODAL_SMALL_SIZE}/>
            :
            null
    );
};

export default AssignGroupToPreferencePopup;
